angular.module('am4').factory('geoService', function($http, apiUrl) {
    return {
        getCountries: function() {
            return $http.get(apiUrl + '/countries', { cache: true }).then(function(res) {
                return res.data;
            });
        },
        getStates: function(id) {
            return $http.get(apiUrl + '/states', {
                cache: true,
                params: {
                    country_id: id
                }
            }).then(function(res) {
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/geo.js